(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/assets/javascripts/views/match.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/assets/javascripts/views/match.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.moq = svs.statistics.moq || {};
  svs.statistics.data = svs.statistics.data || {};

  var log = new svs.core.log.Logger('svs.statistics.views.Match');

  svs.statistics.views.Match = Backbone.View.extend({
    tagName: 'li',
    miniStatisticsExpanded: false,
    className: '',
    viewId: 'matchinfo',
    miniStatisticsLoaded: false,
    events: {
      'click .js-show-match': 'clickedMatch',
      'click .js-expandable-box-header': 'expandStatistics',
      'click .play-now-btn': 'playNow'
    },
    initialize: function(options) {
      options = options || {};
      options.subscribe = options.subscribe || {};
      options.fetch = options.fetch || {};
      options.app = options.app || {};

      this.model = options.modelReference;
      this.model.on('change', this.update, this);

      if (!this.model.getStatusFunction('isEnded', this.model.get('status'))) {
        this.initOddsModel(options);
        this.initDrawsModel(options);
      }
      this.app = options.app;
      this.template = options.templateReference;
      this.matchId = this.model.get('matchId');
      this.homeTeamId = this.model.get('homeTeam').id;
      this.awayTeamId = this.model.get('awayTeam').id;
      this.className = _.isString(options.styleClass) ? options.styleClass : '';
      var _self = this;

      svs.components.Storage.browser.get('miniOpen', 'sportservice', function(
        result
      ) {
        if (result && result[_self.matchId]) {
          _self.$('.js-expandable-box-header').trigger('click', true);
          _self.miniStatisticsExpanded = true;
        }
      });
    },

    initOddsModel: function(options) {
      this.odds = new svs.statistics.models.Odds({
        matchId: this.model.get('matchId'),
        subscribe: options.subscribe.odds,
        fetch: options.fetch.odds
      });

      this.odds.on('change', this.updateOdds, this);
    },

    initDrawsModel: function(options) {
      this.draws = new svs.statistics.models.Draws({
        matchId: this.model.get('matchId'),
        subscribe: options.subscribe.draws,
        fetch: options.fetch.draws
      });

      this.draws.on('change', this.updateDraws, this);
    },

    update: function() {
      log.debug('Updating...');
      if (this.statisticsMiniView) {
        this.statisticsMiniView.destroy();
        delete this.statisticsMiniView;
      }
      this.render();
      if (this.miniStatisticsExpanded) {
        this.$('.js-expandable-box-header').trigger('click', true);
      }
    },

    updateOdds: function() {
      this.model.set('oddsModel', this.odds, { silent: true });
      this.model.set('odds', this.odds.getOdds(), { odds: true });
    },

    updateDraws: function() {
      this.model.set('oddsetDraws', this.draws.getDraws());

      if (this.model.get('response')) {
        this.model.parse(this.model.get('response'));
      }
    },

    render: function() {
      var templateData,
        selected =
          this.$('.match-container').hasClass('selected') ||
          this.$('.match-container').hasClass('panel-inverted');

      if (!this.model.get('league')) {
        log.debug('Trying to render match before owning data.');
        return this;
      }

      this.$el.addClass(this.className);

      templateData = _.extend(this.model.toJSON(), { selected: selected });

      this.$el.html(this.template(templateData));

      return this;
    },

    renderMiniStatistics: function() {
      var hasModel = true;

      if (!this.statisticsMiniModel) {
        this.statisticsMiniModel = new svs.components.models.StatisticsMini({
          matchId: this.matchId,
          homeTeamId: this.homeTeamId,
          awayTeamId: this.awayTeamId
        });
        hasModel = false;
      }
      var $statisticsMini = this.$('.stats-mini');

      if (this.statisticsMiniView) {
        this.statisticsMiniView.destroy();
      }
      this.statisticsMiniView = new svs.components.views.StatisticsMini({
        modelReference: this.statisticsMiniModel
      });

      if (hasModel) {
        $statisticsMini.html(this.statisticsMiniView.render().el);
      } else {
        $statisticsMini.html(this.statisticsMiniView.el);
      }
    },

    expandStatistics: function(e, preload) {
      if (!this.miniStatisticsLoaded) {
        svs.statistics.mini.timer = {};
        svs.statistics.mini.timer.from = 'SportService';
        svs.statistics.mini.timer.time = moment();
        log.debug(
          'miniStat click open at: ' + svs.statistics.mini.timer.time.format()
        );
        svs.core.log.logLevel(
          log,
          svs.core.log.Targets.console,
          svs.core.log.Levels.debug
        );
        this.miniStatisticsLoaded = true;
      } else {
        svs.statistics.mini.timer = false;
      }
      if (
        this.model.get('lazy') ||
        this.model.get('noTemplate') ||
        this.model.get('isVisualLimitedCoverage')
      ) {
        return false;
      }
      var _self = this;

      if (!preload) {
        this.miniStatisticsExpanded = !this.miniStatisticsExpanded;

        svs.components.Storage.browser.get('miniOpen', 'sportservice', function(
          result
        ) {
          var PassedResult = {};
          PassedResult = _.isObject(result) ? result : {};
          if (PassedResult[_self.matchId]) {
            svs.components.Storage.browser.remove(
              'miniOpen',
              'sportservice',
              function() {
                delete PassedResult[_self.matchId];
                svs.components.Storage.browser.set(
                  'miniOpen',
                  'sportservice',
                  PassedResult,
                  svs.components.Storage.constants.EXPIRES_10M
                );
              }
            );
          } else {
            PassedResult[_self.matchId] = true;
            svs.components.Storage.browser.set(
              'miniOpen',
              'sportservice',
              PassedResult,
              svs.components.Storage.constants.EXPIRES_10M
            );
          }
        });
      }

      this.renderMiniStatistics();
    },

    clickedMatch: function(event) {
      var matchId, matchLabel, currentTarget;

      if (
        this.model.get('lazy') ||
        this.model.get('noTemplate') ||
        this.model.get('isVisualLimitedCoverage')
      ) {
        return false;
      }
      svs.components.Storage.browser.set(
        'scrollTo',
        'sportservice',
        this.matchId
      );

      if (svs.core.detect.formfactor.mobile()) {
        return; 
      }

      if (this.app) {
        currentTarget = $(event.currentTarget);

        matchId = currentTarget.data('match-id');
        matchLabel = currentTarget.data('match-label');

        this.selectMatch(matchId);

        Backbone.history.navigate('match/' + matchLabel, {
          trigger: false,
          replace: true
        });
        this.app.radio.request('show-match', {
          matchId: '' + this.matchId,
          model: this.model
        });
      }
      event.preventDefault();
      return false;
    },

    selectMatch: function(matchId) {
      this.$('.match-container').removeClass('panel-inverted');
      this.$('#match-' + matchId).addClass('panel-inverted');
    },

    playNow: function() {
      var self = this;
      if (this.model.get('oddsetDraws')) {
        svs.core.module.load(
          '/cl/sport/oddset-play',
          null,
          function() {
            svs.sport.oddsetplay.showPlayNow(
              self.model.get('oddsetDraws').drawNumber
            );
          },
          false
        );
      }
    },

    onDestroy: function() {
      if (this.statisticsMiniView) {
        this.statisticsMiniView.onDestroy();
        this.statisticsMiniView.dispose();
        delete this.statisticsMiniView;
      }

      if (this.statisticsMiniModel) {
        delete this.statisticsMiniModel;
      }

      if (this.odds) {
        this.odds.stopPush();
      }

      if (this.draws) {
        this.draws.stopPush();
      }

      this.model.stopPush();
      this.model.off();

      delete this.el;
      delete this.$el;
    }
  });
})(Backbone, _, svs);

 })(window);